module.exports = __webpack_public_path__ + "static/media/9f8794c3-3a25-480f-8b29-d125d27369f3.793b0475.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/9f8794c3-3a25-480f-8b29-d125d27369f3.jpg
// module id = 837
// module chunks = 0